import { render, staticRenderFns } from "./EditFollowUp.vue?vue&type=template&id=569498f3&scoped=true"
import script from "./EditFollowUp.vue?vue&type=script&lang=js"
export * from "./EditFollowUp.vue?vue&type=script&lang=js"
import style0 from "./EditFollowUp.vue?vue&type=style&index=0&id=569498f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569498f3",
  null
  
)

export default component.exports